import React from 'react';
import Relay from 'react-relay';
import dateFormat from 'dateformat';

import DateField from './DateField';
import TextField from './TextField';
import Dialog from 'react-bootstrap-dialog';
import Tabs from './Tabs'
import Button from './Button';
import { appStyles, colors, fonts } from '../theme'

class UserNavigationSessions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoadingSessions: true,
            selectedSession: null,
            isLoadingSessionDetails: false
        }
    }

    componentDidMount() {
        this.props.relay.setVariables({
                fetchSessions: true,
                userId: this.props.userId
            }, 
            ({ done, aborted }) => {
                if (done || aborted) 
                    this.setState({
                        isLoadingSessions: false,
                    })
            }
        )
    }

    _seeSession = session => {
        this.setState({
            isLoadingSessionDetails: true,
            selectedSession: session
        }, () => {
            this.props.relay.setVariables({
                fetchSessions: true,
                userId: this.props.userId,
                sessionId: session.id,
                fetchSessionLogs: true
            }, 
            ({ done, aborted }) => {
                if (done || aborted) 
                    this.setState({
                        isLoadingSessionDetails: false,
                    })
                }
            )
        })
    }

    _closeCurrentSession = () => {
        this.setState({
            selectedSession: null
        })
    }

    _formatDate = date => dateFormat(date, "dd/mm/yyyy HH:MM:ss")

    prepareData = (selectedSession, userSessionLogs, userSessionQueryLogs) => {
        let formattedData = [{
            routeName: 'Homepage', 
            startingTime: selectedSession.startingTime,
            endingTime: userSessionLogs[0].navigationTime,
            queries: []
        }]; 

        userSessionLogs.forEach((userSessionLog, index) => {
            formattedData.push({
                routeName: userSessionLog.routeName,
                seenItemId: userSessionLog.seenItemId,
                seenItemType: userSessionLog.seenItemType,
                startingTime: userSessionLog.navigationTime,
                endingTime: index < userSessionLogs.length - 1 ? userSessionLogs[index + 1].navigationTime : selectedSession.endingTime,
                queries: []
            })
        })

        userSessionQueryLogs.forEach(userSessionQueryLog => {
            formattedData.forEach(item => {
                if (new Date(userSessionQueryLog.queryTime) >= new Date(item.startingTime) && new Date(userSessionQueryLog.queryTime) < new Date(item.endingTime))
                    item.queries.push(userSessionQueryLog)
            })
        })

        formattedData.forEach(item => {
            if (item.queries && item.queries.length > 0) {
                item.queries = item.queries.sort((a, b) => {
                    if (new Date(a.queryTime) > new Date(b.queryTime))
                        return 1
                    else if (new Date(a.queryTime) < new Date(b.queryTime))
                        return -1
                    else return 0
                })
            }
        })

        return formattedData; 
    }

    render() {
        const { viewer } = this.props ; 
        const { isLoadingSessions, selectedSession, isLoadingSessionDetails } = this.state ;
        console.log("viewer", viewer);
        const sessionHeight = selectedSession
            ?   (new Date(selectedSession.endingTime) - new Date(selectedSession.startingTime)) / 10
            :   0 ;
        const preparedData = selectedSession && viewer.userSessionLogs && viewer.userSessionLogs.length > 0 && viewer.userSessionQueryLogs && viewer.userSessionQueryLogs.length > 0
            ?   this.prepareData(selectedSession, viewer.userSessionLogs, viewer.userSessionQueryLogs)
            :   []; 

        console.log("preparedData", preparedData);

        return (
            <div>
                {isLoadingSessions
                ?   <h4>
                        Loading sessions
                    </h4>
                :   <table className="table table-hover table-condensed">
                        <thead>
                            <tr>
                                <th>NO.</th>
                                <th>Mobile version</th>
                                <th>Session start</th>
                                <th>Session end</th>
                                <th>See details</th>
                            </tr>
                        </thead>

                        <tbody>
                            {viewer && viewer.userSessions && 
                            viewer.userSessions
                            .filter(userSession => !selectedSession || selectedSession.id === userSession.id)
                            .map((userSession, index) => (
                                <tr 
                                    className={null}
                                    key={index}
                                >
                                    <td>
                                        {index}
                                    </td>

                                    <td>
                                        {userSession.mobileVersion}
                                    </td>
                                    
                                    <td>
                                        {this._formatDate(userSession.startingTime)}
                                    </td>
                                    
                                    <td>
                                        {this._formatDate(userSession.endingTime)}
                                    </td>

                                    <td>
                                        <button 
                                            type="button" 
                                            className={selectedSession ? "btn btn-danger btn-sm" : "btn btn-success btn-sm"}
                                            onClick={() => selectedSession ? this._closeCurrentSession() : this._seeSession(userSession)}
                                        >
                                            {selectedSession 
                                            ?   "Close details"
                                            :   "See details"
                                            }
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                }

                {selectedSession && (
                    isLoadingSessionDetails
                    ?   <h4>
                            Loading session details
                        </h4>
                    :   <div style={{backgroundColor: colors.lightGray, width: '100%'}}>
                            <div style={styles.sessionDetailsContainer}>
                                <div style={{flex: 1}}>
                                    <h4>
                                        Navigation
                                    </h4>
                                </div>

                                <div style={{flex: 4}}>
                                    <h4>
                                        Queries
                                    </h4>
                                </div>
                            </div>

                            <div style={{height: sessionHeight, position: 'relative'}}>
                                {preparedData.map((dataItem, index) => (
                                    <div 
                                        key={index}
                                        style={{
                                            position: 'absolute', 
                                            top: (new Date(dataItem.startingTime) - new Date(selectedSession.startingTime)) / 10,
                                            ...styles.sessionDetailsContainer
                                        }}
                                    >
                                        <div style={{flex: 1}}>
                                            {dataItem.routeName} - {this._formatDate(dataItem.startingTime)}
                                            
                                            {dataItem.seenItemType && 
                                                <div>
                                                    {dataItem.seenItemType}
                                                </div>
                                            }

                                            {dataItem.seenItemId && 
                                                <div>
                                                    {dataItem.seenItemId}
                                                </div>
                                            }
                                        </div>

                                        <div style={{flex: 4, position: 'relative'}}>
                                            {dataItem.queries.map((queryLog, queryLogIndex) => (
                                                <div 
                                                    key={queryLogIndex}
                                                    style={{
                                                        wordBreak: 'break-word', 
                                                        position: 'absolute', 
                                                        top: (new Date(queryLog.queryTime) - new Date(dataItem.startingTime)) / 10, 
                                                        left: (queryLogIndex * 80),
                                                        width: 70,
                                                        fontSize: 12,
                                                        color: queryLog.queryDuration > 600 ? colors.red : colors.black
                                                    }}
                                                >
                                                    {queryLog.routeName} - {this._formatDate(queryLog.queryTime)} - {queryLog.queryDuration}ms
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                )}
            </div>
        )
    }
}

export default Relay.createContainer(UserNavigationSessions, {
  initialVariables: {
    fetchSessions: false,
    userId: null,
    sessionId: null,
    fetchSessionLogs: false
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        userSessions (userId: $userId) @include (if: $fetchSessions) {
            id
            startingTime
            endingTime
            mobileVersion
        }
        userSessionLogs(sessionId: $sessionId) @include (if: $fetchSessionLogs) {
            id
            routeName
            navigationTime
            seenItemId
            seenItemType
        }
        userSessionQueryLogs(sessionId: $sessionId) @include (if: $fetchSessionLogs) {
            id
            routeName
            queryTime
            queryDuration,
        }
      }
    `
  }
});

const styles = {
	list: {
		width: '100%',
	},
	listItem: {
		paddingBottom: 10,
		color: '#515151',
		fontSize: 16,
		fontWeight: 500,
		fontFamily: 'Lato',
		borderBottomWidth: 1,
		borderColor: colors.blue,
		borderStyle: 'solid',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		maxWidth: 500,
	},
    sessionDetailsContainer: {
        display: 'flex', 
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        width: '100%'
    }
}



// WEBPACK FOOTER //
// ./src/components/UserNavigationSessions.js